import * as React from "react"

import { IDiscount } from "shared/hubrise/models"

import Delete from "./Delete"

const Commands = ({ discount }: { discount: IDiscount }): JSX.Element => <Delete discount={discount} />

export default Commands
